<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import { parseFilterParams } from '../model/filters/parse-filter-params'
import { useOnboardingApi } from '../api/onboarding.hook'
import TutorKanbanTable from './TutorKanbanTable.vue'

defineOptions({
  name: 'TutorKanbanOnboardingPage',
})

const route = useRoute()

useOnTimezoneChange(() => {
  const params = parseFilterParams(route.query)
  void useOnboardingApi({ params })
})
</script>

<template>
  <TutorKanbanTable />
</template>
